const VarIcon = ({ width = '17px', height = '15px' }) => {
    return (
        <div
            style={{
                fontSize: '6px',
                borderRadius: '4px',
                width: width,
                height: height,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
                backgroundColor: '#e11d48',
            }}
        >
            VAR
        </div>
    );
};

export default VarIcon;
